import { render, staticRenderFns } from "./RecordFiles.vue?vue&type=template&id=1b7c3824&scoped=true"
import script from "./RecordFiles.vue?vue&type=script&lang=js"
export * from "./RecordFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c3824",
  null
  
)

export default component.exports